var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCardBack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 506,
    height: 291,
    viewBox: "0 0 506 291",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M481.301 286.701L26.8007 290.601C13.2007 290.701 2.10068 279.801 2.00068 266.201L0.000682599 28.7007C-0.0993174 15.1007 10.8007 4.00069 24.4007 3.90069L478.901 0.000682599C492.501 -0.0993174 503.601 10.8007 503.701 24.4007L505.701 261.901C505.901 275.501 494.901 286.601 481.301 286.701Z",
    fill: "#3E8C9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M503.93 43.2433L0.130417 47.583L0.699802 113.683L504.5 109.343L503.93 43.2433Z",
    fill: "#1B4A59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.801 138.901H106.301V193.301H395.801V138.901Z",
    fill: "#E6E6E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M463.601 218.5H44.7007V226.5H463.601V218.5Z",
    fill: "#37808C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M463.601 244.101H44.7007V252.101H463.601V244.101Z",
    fill: "#37808C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardBack);
export default __webpack_public_path__ + "static/media/credit-card-back.59bd13e47d890de3fd8e7a869912ef7a.svg";
export { ForwardRef as ReactComponent };